import { cn } from "@/lib/utils"
import CheckIcon from "@/components/icons/check"
import { Cross2Icon, ReloadIcon } from "@radix-ui/react-icons"
import { VariantProps, cva } from "class-variance-authority"

const variants = cva(
  "flex-shrink-0 rounded-md flex items-center justify-center shadow w-8 h-8 text-white",
  {
    variants: {
      status: {
        pending: "border",
        success: "bg-blue-500",
        failed: "bg-red-500",
        loading: "border text-gray-400",
      },
      size: {
        md: "w-6 h-6",
        lg: "w-8 h-8",
      },
    },
  },
)

export default function StatusBox({
  status,
  size,
}: VariantProps<typeof variants>) {
  return (
    <div className={cn(variants({ status, size }))}>
      {status === "success" && <CheckIcon />}
      {status === "failed" && <Cross2Icon />}
      {status === "loading" && (
        <div className="animate-spin">
          <ReloadIcon />
        </div>
      )}
    </div>
  )
}
